"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1576))
 * @lastsynced 2026-10-29T13:51:23.406Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const EyeClosed = createSVGIcon(
  <path
    d="M20.44 8.727a24 24 0 0 1 2.247 2.131 1.656 1.656 0 0 1 0 2.284C20.88 15.086 16.776 18.857 12 18.857a9.7 9.7 0 0 1-1.687-.152M4.08 15.693a23.6 23.6 0 0 1-2.767-2.551 1.656 1.656 0 0 1 0-2.284C3.12 8.914 7.223 5.143 12 5.143c.839.003 1.674.113 2.486.329m.841 7.36a3.43 3.43 0 0 1-2.496 2.495M8.571 12A3.43 3.43 0 0 1 12 8.571m9.428-6L2.571 21.43"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "EyeClosed",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
